import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePlayer } from "../context/MusicPlayerContext";

const MUSIC_ROUTE = "/"; // the route(s) music should play on

const RouteMusicSync: React.FC = () => {
  const location = useLocation();
  const { play, pause } = usePlayer();

  useEffect(() => {
    if (location.pathname === MUSIC_ROUTE) {
      play();
    } else {
      pause();
    }
  }, [location.pathname]);

  return null;
};

export default RouteMusicSync;